var render = function render(){var _vm=this,_c=_vm._self._c;return _c('element-loader',{staticClass:"section-loader",attrs:{"color":"#4F71C3","loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }